import * as PRTNR from "./prtnr";

import styled from "@emotion/styled";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import GenericModal from "./GenericModal";
import { updateVendorUser } from "./redux/slices/authThunks";
import ModalUpdateSuccess from "./ModalUpdateSuccess";
import Navbar from "./shared/Navbar";
import { OutlineEye, OutlineEyeOff } from "./assets";

function ChangePassword() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [oldPasswordError, setOldPasswordError] = useState("");
  const [newPasswordError, setNewPasswordError] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [passwordError, setPasswordError] = useState("");
  const [showPassword, setshowPassword] = useState(false);
  const [showNewpass, setshowNewpass] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const validatePassword = (password) => {
    const regex = /^(?=.*[A-Za-z])(?=.*\d).{8,}$/;

    if (!password) {
      return { valid: false, message: "New password is required" };
    }

    if (!regex.test(password)) {
      return {
        valid: false,
        message:
          "Password must be at least 8 characters with a mix of letters & numbers.",
      };
    }

    return { valid: true };
  };
  const handleSubmit = async () => {
    // Reset errors
    setOldPasswordError("");
    setNewPasswordError("");
    setPasswordError("");

    let hasError = false;

    // Validate old password
    if (!oldPassword) {
      setOldPasswordError("Old password is required");
      hasError = true;
    }

    // Validate new password
    const validation = validatePassword(newPassword);
    if (!validation.valid) {
      setNewPasswordError(validation.message);
      hasError = true;
    } else if (oldPassword && newPassword === oldPassword) {
      setNewPasswordError(
        "New password must be different from the old password"
      );
      hasError = true;
    }

    if (hasError) return;

    // Get user from localStorage
    const vendor = JSON.parse(localStorage.getItem("user") || "{}");
    if (!vendor?._id) {
      setPasswordError("User session has expired. Please log in again.");
      return;
    }

    const payload = {
      _id: vendor._id,
      oldPassword,
      newPassword,
    };

    try {
      await dispatch(updateVendorUser(payload)).unwrap();
      openModal();
    } catch (error) {
      // Handle API error message
      if (typeof error === "string") {
        setPasswordError(error);
      } else if (error?.message) {
        setPasswordError(error.message);
      } else {
        setPasswordError("Failed to update password. Please try again later.");
      }
    }
  };

  return (
    <RootWrapperHome>
      <Section>
        <Wrapper>
          <SignupSignin>
            <ContentBlock1>
              <Content>
                <EarningCashForMakingReferralsIsEasierThanEver>
                  Settings
                </EarningCashForMakingReferralsIsEasierThanEver>
              </Content>
            </ContentBlock1>
            <Frame58>
              <Legal>Change Password</Legal>
              <PRTNR.Input
                label="Old Password"
                type={showPassword ? "text" : "password"}
                icon={showPassword ? OutlineEye : OutlineEyeOff}
                onIconClick={() => setshowPassword(!showPassword)}
                value={oldPassword}
                error={!!oldPasswordError}
                errorMessage={oldPasswordError}
                onChange={(e) => {
                  setOldPassword(e.target.value);
                }}
              />

              <PRTNR.Input
                label="New Password"
                value={newPassword}
                type={showNewpass ? "text" : "password"}
                icon={showNewpass ? OutlineEye : OutlineEyeOff}
                onIconClick={() => setshowNewpass(!showNewpass)}
                onChange={(e) => {
                  setNewPassword(e.target.value);
                }}
                error={!!newPasswordError}
                errorMessage={newPasswordError}
                required
              />
              {passwordError && <ErrorMessage>{passwordError}</ErrorMessage>}
              <GetStarted>
                Password must be at least 8 characters with a mix of letters &
                numbers.
              </GetStarted>
            </Frame58>
          </SignupSignin>
          <Frame1500>
            <div style={{ width: "100px" }}>
              <PRTNR.Button
                variant="gray"
                onClick={() => {
                  setOldPassword("");
                  setNewPassword("");
                  navigate(-1);
                }}
                style={{ backgroundColor: "rgba(226, 232, 240, 1)" }}
              >
                Discard
              </PRTNR.Button>
            </div>

            <Frame1399>
              <PRTNR.Button
                variant="black"
                onClick={() => {
                  handleSubmit();
                }}
              >
                Save Changes
              </PRTNR.Button>
            </Frame1399>
          </Frame1500>
        </Wrapper>
      </Section>

      <GenericModal isOpen={isModalOpen} onClose={closeModal}>
        <ModalUpdateSuccess isOpen={isModalOpen} onClose={closeModal} />
      </GenericModal>
    </RootWrapperHome>
  );
}

const RootWrapperHome = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
`;

const Section = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  flex: 1;
  gap: 8px;
  align-self: stretch;
  background: rgb(241, 245, 249);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  flex-shrink: 0;
  padding-inline: clamp(1rem, 5vw, 3.75rem);
  padding-bottom: clamp(1rem, 5vw, 3.75rem);
  @media (max-width: 1024px) and (min-width: 768px) {
    padding-bottom: 16px;
  }

  @media (max-width: 767px) {
    padding-bottom: 16px;
  }
`;

const Wrapper = styled.div`
display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  margin-top: 32px;
`;

const SignupSignin = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const ContentBlock1 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  gap: 32px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Content = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  flex: 1;
  width: 560px;
  box-sizing: border-box;
  @media (max-width: 1024px) and (min-width: 768px) {
    width: 100%;
  }

  @media (max-width: 767px) {
    width: 100%;
  }
`;

const EarningCashForMakingReferralsIsEasierThanEver = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: clamp(1.5rem, 5vw, 3rem);
  font-family: Montserrat, sans-serif;
  font-weight: 600;
  letter-spacing: -1px;
  text-align: flex-start;
  align-self: stretch;
  flex-shrink: 0;
`;

const Frame58 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  flex: none;
  gap: 24px;
  border: solid 1px rgba(136, 136, 136, 0.1);
  border-radius: 32px;
  width: 878px;
  background: rgba(255, 255, 255, 1);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 32px;
  @media (max-width: 1024px) and (min-width: 768px) {
    width: 100%;
  }

  @media (max-width: 767px) {
    width: 100%;
  }
`;

const Legal = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 24px;
  font-family: Montserrat, sans-serif;
  font-weight: 600;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;
const ErrorMessage = styled.span`
  color: rgb(220, 38, 38);
  font-size: 12px;
  font-family: Montserrat, sans-serif;
  margin-top: 4px;
  text-align: left;
  width: 100%;
`;

const GetStarted = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 600;
  line-height: 140%;
  text-align: flex-start;
`;

const Frame1500 = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-end;
  flex-direction: row;
  margin-top: 20px;
  align-items: center;
  flex: none;
  gap: 17px;
  box-sizing: border-box;
`;

const Frame1399 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  flex: none;
  gap: 16px;
  box-sizing: border-box;
`;

export default ChangePassword;
